module.exports = __webpack_public_path__ + "static/img/help_center.aa24aaca.png";